<div class="page">
  <div class="header">
    <button mat-icon-button type="button" (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>Receta más reciente</h1>

      <p>
        {{ paciente.nombre }}
        {{ paciente.apellido }}
        {{ paciente.segundoApellido }}
      </p>
    </div>
  </div>

  <div class="body">
    @if (cargando) {
      <p class="sin-datos">Cargando información...</p>
    } @else if (recetas.length === 0) {
      <div class="sin-datos">
        <mat-icon class="material-symbols-outlined"> document_search </mat-icon>

        <h2>Este paciente no tiene recetas registradas</h2>
      </div>
    } @else {
      @for (receta of recetas; track receta.id) {
        <div class="receta-card">
          <div class="receta-header">
            <mat-icon>event_note</mat-icon>

            <div>
              <strong>Folio: {{ receta.folio }}</strong>

              <p>Expediente: {{ receta.expediente }}</p>

              <span class="fecha-receta">
                <mat-icon>calendar_month</mat-icon>
                {{ obtenerFecha(receta.fecha) }}
              </span>
            </div>
          </div>

          @if (receta.padecimiento) {
            <div class="bloque">
              <span class="etiqueta"> Padecimiento </span>

              <p>
                {{ receta.padecimiento }}
              </p>
            </div>
          }

          @if (receta.hallazgos) {
            <div class="bloque">
              <span class="etiqueta"> Hallazgos </span>

              <p>
                {{ receta.hallazgos }}
              </p>
            </div>
          }

          @if (receta.impresion) {
            <div class="bloque">
              <span class="etiqueta"> Impresión </span>

              <p>
                {{ receta.impresion }}
              </p>
            </div>
          }

          <div class="bloque">
            <span class="etiqueta"> Médico </span>

            <p>
              {{ receta.medico.nombre }}
              {{ receta.medico.apellidoPaterno }}
              {{ receta.medico.apellidoMaterno }}
            </p>
          </div>

          @if (receta.medicamentos.length > 0) {
            <div class="bloque">
              <span class="etiqueta"> Medicamentos </span>

              <ul>
                @for (med of receta.medicamentos; track med.medicamento) {
                  <li>
                    <strong>
                      {{ med.medicamento }}
                    </strong>

                    — {{ med.dosis }}, {{ med.frecuencia }}, {{ med.duracion }},
                    {{ med.administracion }}
                  </li>
                }
              </ul>
            </div>
          }

          @if (receta.estudios.length > 0) {
            <div class="bloque">
              <span class="etiqueta"> Estudios solicitados </span>

              <ul>
                @for (estudio of receta.estudios; track estudio.nombre) {
                  <li>
                    <strong>
                      {{ estudio.nombre }}
                    </strong>

                    @if (estudio.indicaciones) {
                      — {{ estudio.indicaciones }}
                    }
                  </li>
                }
              </ul>
            </div>
          }

          <div class="acciones-receta">
            <button mat-flat-button class="add-boton" type="button" (click)="regenerarPDF(receta)">
              <mat-icon>picture_as_pdf</mat-icon>
              Mostrar PDF
            </button>
          </div>
        </div>
      }
    }
  </div>
</div>
